const main = (resolve) => require(['@/views/index/index.vue'], resolve) // 主页

const keySetting = (resolve) =>
  require(['@/views/accountCenter/keySetting.vue'], resolve) // 密钥设置

const Certification = (resolve) =>
  require(['@/views/certification/Certification.vue'], resolve) // 实名认证

const CertificationUpdate =  (resolve) =>
  require(['@/views/certification/update/index.vue'], resolve) // 法人、受益人、股东、公司证件更新

const CashAccount = (resolve) =>
  require(['@/views/cashAccount/index.vue'], resolve) // 提现账户

const AutoWithdrawal = (resolve) =>
require(['@/views/cashAccount/autoWithdrawal.vue'], resolve) // 自动提现

const MessageReceiverSetting = resolve =>
  require(['@/views/messageReceiverSetting/index.vue'], resolve) // 邮件接收设置

// const MessageReceiverSetting = resolve =>
// 	require(["views/messageReceiverSetting/index.vue"], resolve); // 邮件接收设置

const WthdrawOperationManual = resolve =>
  require(['@/components/WthdrawOperationManual/index.vue'], resolve) // 邮件接收设置

const OfflineKyc = (resolve) =>
  require(['@/views/offlineKyc/index.vue'], resolve) // 线下KYC

const OfflineKycExipreUpdate =  (resolve) =>
  require(['@/views/offlineKyc/update/index.vue'], resolve) // 线下KYC证件过期更新

export default [
  {
    path: '/index',
    component: main,
    children: [
      // 密钥设置
      {
        name: 'KeySetting',
        path: '/aq/keySetting',
        alias: ['/aq/keySetting.htm'],
        component: keySetting
      },
      // 实名认证
      {
        name: 'Certification',
        path: '/aq/certification',
        alias: ['/aq/certification.htm'],
        component: Certification
      },
      {
        name: 'CertificationUpdate',
        path: '/aq/certificationUpdate',
        alias: ['/aq/certificationUpdate.htm'],
        component: CertificationUpdate,
      },
      // 提现账户
      {
        name: 'CashAccount',
        path: '/aq/cashAccount',
        alias: ['/aq/cashAccount.htm'],
        component: CashAccount
      },
      {
        name: 'AutoWithdrawal',
        path: '/aq/autoWithdrawal',
        alias: ['/aq/autoWithdrawal.htm'],
        component: AutoWithdrawal
      },
      // 提现操作指南
      {
        name: 'WithdrawOperationManual',
        path: '/aq/WthdrawOperationManual',
        alias: ['/aq/WthdrawOperationManual.htm'],
        component: WthdrawOperationManual

      },
      // 邮件接收设置
      {
        name: 'MessageReceiverSetting',
        path: '/aq/messageReceiverSetting',
        alias: ['/aq/messageReceiverSetting.htm'],
        component: MessageReceiverSetting
      },
      // 线下实名认证
      {
        name: 'OfflineKyc',
        path: '/aq/offlineKyc',
        alias: ['/aq/offlineKyc.htm'],
        component: OfflineKyc
      },
      // 线下KYC证件过期更新
      {
        name: 'offlineKycExipreUpdate',
        path: '/aq/offlineKycExipreUpdate',
        alias: ['/aq/offlineKycExipreUpdate.htm'],
        component: OfflineKycExipreUpdate,
      },
    ]
  }
]
